import { Outlet, useParams } from "react-router-dom";
import { TabsFormLayoutV2 } from "src/framework/form/TabsFormLayoutV2.tsx";
import { useModuleRoutePaths } from "src/system/useModuleRoutePaths.ts";
import { camelToKebabCase } from "@exonn/utils";
import { useModule } from "src/system/useModule.tsx";
import { FormAction } from "src/components/Form/Form.types.ts";

export type EditLayoutV2Props = {
  resource: string;
  layoutForm?: boolean;
};

export function EditLayoutV2(props: EditLayoutV2Props) {
  const { resource, layoutForm } = props;

  const paths = useModuleRoutePaths({
    resource,
  });

  const params = useParams();

  const { formTabs: formTabsConfig } = useModule(resource);

  const formTabs = formTabsConfig || {};

  const tabs = Object.keys(formTabs).map((key, index) => {
    const isFirstTab = index === 0;
    const path = isFirstTab
      ? paths.edit.root
      : paths.edit.tab(camelToKebabCase(key)).root;
    const tabConfig = formTabs[key];
    return {
      path: path,
      title: tabConfig.title,
      isDisabled: tabConfig.isDisabled,
      disabledTooltip: tabConfig.disabledTooltip,
      isHidden: tabConfig.isHidden,
      key,
    };
  });

  if (tabs) {
    return (
      <TabsFormLayoutV2
        type={FormAction.Edit}
        layoutForm={layoutForm}
        tabs={tabs}
        key={
          // to prevent sharing state between instances of the component
          params["id"]
        }
        resource={resource}
      />
    );
  }

  return <Outlet key={params["id"]} />;
}
